// extracted by mini-css-extract-plugin
export var copyable = "_c-1";
export var explainable = "_c-0";
export var negative = "_c-2";
export var positive = "_c-3";